<template>
  <div>
    <LvText v-if="title" h6 bold>
      {{ $t(title) }}
    </LvText>
    <WsButton001 class="mt-8" @click="$_onOpenPopup()">
      {{ $t(btnText) }}
    </WsButton001>
    <LvFlexBox v-if="value && value.length > 0">
      <WsButton001
        v-for="(item, itemIndex) in value"
        :key="itemIndex"
        flat-button
        out-line
        non-min-width
        :trailingIcon="item.trailingIcon"
        :style="{ height: '32px' }"
        class="mt-4 mr-4"
        @click="$_onRemoveItem(item)"
      >
        {{ item.text }}
      </WsButton001>
    </LvFlexBox>
    <PopUp
      bottom
      ref="LvLawPick"
      :title="$t(`${title}`)"
      :clickOutsideClose="false"
      :popUpActive="isActive.popup"
      @click="$_onClosePopup()"
      @scroll="$_onScroll($event)"
    >
      <div v-if="ingStep === 0">
        <LlState v-model="filterState.act.search" type="search" placeholder="搜尋" />
        <LlPaginateList
          :isloading="isLoading.items"
          :page-count="paginate.lastPage"
          :page-range="3"
          :margin-pages="3"
          :first-button-text="_paginationFirstButtonText"
          :last-button-text="_paginationLastButtonText"
          :prev-text="_paginationPrevText"
          :next-text="_paginationNextText"
          :container-class="'pagination'"
          first-last-button
          :page="paginate.ingPage"
          :from-data-num="paginate.fromDataNum"
          :to-data-num="paginate.toDataNum"
          :total-data-num="paginate.totalDataNum"
          class="ml-0"
          @input="$_onChangePaginatePage($event, 'act')"
        >
          <DataTable
            :isloading="isLoading.items"
            :column-header="_columnHeader"
            :row-data="items"
            @click="$_onClickAct($event)"
          />
        </LlPaginateList>
      </div>
      <div v-if="ingStep === 1">
        <WsTitle001 h6 bold class="mb-8 mt-20">
          {{ $t('法規名稱') }}
        </WsTitle001>
        <WsText001 h6 class="mb-20">
          {{ _selectActText }}
        </WsText001>
        <LvStateRadioBtn
          v-model="radio.value"
          row
          is-narrow
          :title="$t('綁定種類')"
          :radio-button-item="radio.items"
          class="mb-30 h5"
        />
        <LlState
          v-if="radio.value === 1"
          v-model="filterState.article.search"
          type="search"
          placeholder="搜尋"
        />
        <DataTable
          v-if="radio.value === 1"
          :isloading="isLoading.items"
          :column-header="_columnHeader"
          :row-data="items"
          @check="$_onCheckArticle($event)"
        >
          <template v-slot="{ rowItem }">
            <div class="py-12 pl-12">
              <LvText h4 bold class="mb-4">{{ rowItem.text }}</LvText>
              <LvArticleContent
                :isCollapsable="filterState.article.search === ''"
                :richContent="rowItem.content"
                @toggle-collapse="$_onToggleCollapse($event)"
              />
            </div>
          </template>
        </DataTable>
        <DotLoading v-if="isLoading.items" />
      </div>
      <template slot="bottomBtn">
        <WsButton001 out-line @click="$_onClosePopup()">
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001 v-if="ingStep === 1" out-line @click="$_onClickPreStep()">
          {{ $t('上一步') }}
        </WsButton001>
        <WsButton001 v-if="ingStep === 1" class="mt-0" @click="$_onSubmitAct()">
          {{ $t('送出') }}
        </WsButton001>
      </template>
    </PopUp>
  </div>
</template>

<script>
import S_Act from '@/service/api/v1/act';
import S_Article from '@/service/api/v1/article';

export default {
  name: 'LvLawPick',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '選擇',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: {
        popup: false,
      },
      isLoading: {
        items: false,
      },
      ingStep: 0,
      items: [],
      paginate: {
        lastPage: 1,
        ingPage: 1,
        fromDataNum: 0,
        toDataNum: 0,
        totalDataNum: 0,
      },
      select: [],
      radio: {
        value: 0,
        items: {
          buttonItems: [
            {
              id: 0,
              value: 'act',
              textLabel: this.$t('綁定整部法規'),
            },
            {
              id: 1,
              value: 'article',
              textLabel: this.$t('綁定特定法條'),
            },
          ],
        },
      },
      actStatusId: '',
      filterState: {
        act: {
          search: '',
        },
        article: {
          search: '',
        },
      },
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _paginationPrevText() {
      return '<i class="icon-chevron-back" />';
    },
    _paginationNextText() {
      return '<i class="icon-chevron-forward" />';
    },
    _paginationFirstButtonText() {
      return '<i class="icon-chevron-back-start" />';
    },
    _paginationLastButtonText() {
      return '<i class="icon-chevron-forward-end" />';
    },
    _columnHeader() {
      switch (this.ingStep) {
        case 0:
          return [
            {
              id: 'text',
              textLabel: '法規名稱',
              type: 'text',
              tabletHide: false,
            },
          ];
        case 1:
          return [
            {
              id: 'isChecked',
              type: 'checkbox',
              tabletHide: false,
              width: '10px',
            },
            {
              id: 'text',
              textLabel: '法條名稱',
              type: 'slot',
              tabletHide: false,
            },
          ];
        default:
          return [];
      }
    },
    _selectActText() {
      const tarAct = this.select.find(item => item.type === 'act');
      return tarAct.text;
    },
  },
  watch: {
    'filterState.act.search': {
      async handler() {
        await this.$_getActList();
      },
    },
    'filterState.article.search': {
      async handler() {
        if (this.radio.value === 1) {
          this.$_resetItems();
          this.$_resetPagination();
          await this.$_getArticleList();
        }
      },
    },
    'radio.value': {
      async handler(newValue) {
        if (newValue === 1) {
          this.$_resetItems();
          this.$_resetPagination();
          await this.$_getArticleList();
        }
      },
    },
  },
  methods: {
    async $_onOpenPopup() {
      this.isActive.popup = true;
      this.isLoading.items = true;
      if (!this.actStatusId) this.actStatusId = await this.$_getActStatusId();
      await this.$_getActList();
    },
    $_onClosePopup() {
      this.isActive.popup = false;
      this.ingStep = 0;
      this.select = [];
      this.radio.value = 0;
      this.$_resetItems();
      this.$_resetPagination();
      this.$_resetFilterState('act');
      this.$_resetFilterState('article');
    },
    async $_onChangePaginatePage($event, type) {
      const page = $event;
      if (type === 'act') {
        await this.$_getActList(page);
      }
    },
    $_onClickAct($event) {
      const { id } = $event;
      const tarAct = this.items.find(act => act.id == id);
      this.select.push(tarAct);
      this.$_resetItems();
      this.$_resetPagination();
      this.ingStep = 1;
    },
    $_onCheckArticle($event) {
      const { item, isChecked } = $event;
      if (isChecked) {
        this.select.push({
          ...item,
          isChecked: true,
        });
      } else {
        const tarIndex = this.select.findIndex(law => law.id === item.id && law.type === item.type);
        this.select.splice(tarIndex, 1);
      }
    },
    async $_onClickPreStep() {
      this.ingStep -= 1;
      this.select = [];
      this.radio.value = 0;
      this.$_resetItems();
      this.$_resetPagination();
      await this.$_getActList();
    },
    async $_getActList(page) {
      this.isLoading.items = true;
      const params = {
        order_by: 'announce_at',
        order_way: 'desc',
        page: page ? page : 1,
        time_field: 'announce_at',
        act_status: this.actStatusId,
        search: this.filterState.act.search,
      };
      const res = await S_Act.actIndex(this._currentFactoryId, params);
      this.items = this.$_setActItems(res.data);
      this.paginate = {
        lastPage: res.meta.last_page,
        ingPage: res.meta.current_page,
        fromDataNum: res.meta.from,
        toDataNum: res.meta.to,
        totalDataNum: res.meta.total,
      };
      this.isLoading.items = false;
    },
    $_setActItems(rawItems) {
      const result = rawItems.map(item => {
        const { id, last_version: lastVersion } = item;
        const { id: versionId, name: text } = lastVersion;
        return {
          id,
          versionId,
          text,
          type: 'act',
        };
      });
      return result;
    },
    async $_getArticleList(isScroll) {
      this.isLoading.items = true;
      const params = {
        order_by: 'no_number',
        order_way: 'asc',
        page: this.paginate.ingPage,
        act_versions: this.select[0].versionId,
        search: this.filterState.article.search,
      };
      const res = await S_Article.versionIndexSearch(params);
      const newItems = this.$_setArticleItems(res.data, []);
      this.items = isScroll ? [...this.items, ...newItems] : newItems;
      this.paginate = {
        lastPage: res.meta.last_page,
        ingPage: res.meta.current_page,
        fromDataNum: res.meta.from,
        toDataNum: res.meta.to,
        totalDataNum: res.meta.total,
      };
      if (this.paginate.ingPage === 1 && this.paginate.lastPage >= 2) {
        this.paginate.ingPage += 1;
        await this.$_getArticleList(true);
      }
      this.isLoading.items = false;
    },
    $_setArticleItems(rawItems, selectArticleList) {
      return rawItems.map(item => {
        const { article, id: versionId, no_text, content, rich_content } = item;
        const tarIndex = selectArticleList.findIndex(
          selectedArticle =>
            selectedArticle.type === 'article' && selectedArticle.id === article.id,
        );
        return {
          id: article.id,
          versionId,
          text: `${article.act_version.name} ${no_text}`,
          content: this.$_highlightTextWithStyle(
            { rich_content, content },
            this.filterState.article.search,
          ),
          isChecked: tarIndex >= 0,
          type: 'article',
        };
      });
    },
    $_highlightTextWithStyle({ rich_content, content }, keyword) {
      const textWithBreak = rich_content ? rich_content : content;
      if (!keyword) return textWithBreak;
      const sanitizedText = keyword
        .replace(/'/g, '&#39;')
        .replace(/"/g, '&quot;')
        .replace(/“/g, '&ldquo;')
        .replace(/”/g, '&rdquo;');
      const regex = new RegExp(sanitizedText, 'g');
      return textWithBreak.replace(
        regex,
        match => `<span style="background-color: var(--yellow-400);">${match}</span>`,
      );
    },
    $_resetItems() {
      this.items = [];
    },
    $_resetPagination() {
      this.paginate = {
        lastPage: 1,
        ingPage: 1,
        fromDataNum: 0,
        toDataNum: 0,
        totalDataNum: 0,
      };
    },
    $_resetFilterState(type) {
      this.filterState[type].search = '';
    },
    $_onSubmitAct() {
      const radioValue = this.radio.value;
      let select = [];
      let resultArr = [...this.value];
      if (radioValue === 0) {
        select = this.select.find(_select => _select.type === 'act');
        resultArr.push({
          ...select,
          trailingIcon: 'icon-cancel',
        });
      } else if (radioValue === 1) {
        const act = this.select.find(_select => _select.type === 'act');
        const versionId = act.versionId;
        select = this.select
          .filter(_select => _select.type === 'article')
          .map(_select => {
            return {
              ..._select,
              actVersionId: versionId,
              trailingIcon: 'icon-cancel',
            };
          });
        resultArr = [...resultArr, ...select];
      }
      this.$emit('input', resultArr);
      this.$_onClosePopup();
    },
    $_onRemoveItem(law) {
      const resultArr = [...this.value];
      const tarIndex = resultArr.findIndex(_law => {
        return _law.type === law.type && _law.id === law.id;
      });
      resultArr.splice(tarIndex, 1);
      this.$emit('input', resultArr);
    },
    async $_onScroll($event) {
      if (this.ingStep === 0 || this.radio.value !== 1) return;
      const { scrollTotalHeight, windowTotalHeight, scrollTop } = $event;
      const allScrollHeight = scrollTotalHeight - windowTotalHeight;
      const scrollHeight = scrollTop;
      if (scrollHeight / allScrollHeight > 0.9 && !this.isLoading.items) {
        if (this.paginate.ingPage < this.paginate.lastPage) {
          this.paginate.ingPage += 1;
          await this.$_getArticleList(true);
        }
      }
    },
    async $_getActStatusId() {
      const localeCode = this.$store.state.stone_locale.selectingLocale.code;
      let examText = '';
      if (localeCode === 'tw') examText = '現行';
      else if (localeCode === 'cn') examText = '現行有效';
      const params = { factory: this._currentFactoryId };
      const res = await this.$axios.get('/act_status', { params });
      /// 沒辦法用id篩選，因為dev跟prd的法規狀態id不一樣，暫時用每種狀態的繁中來篩選
      const tarActStatus = res.data.data.find(
        data => data.locales.tw && data.locales.tw.name === examText,
      );
      return tarActStatus ? tarActStatus.id : '';
    },
    $_onToggleCollapse({ isCollapse, top }) {
      const popup = this.$refs.LvLawPick;
      const popupTop = popup.$el.getBoundingClientRect().top;
      if (!isCollapse || top - popupTop > 0) return;
      const scrollbar = popup.$refs.perfectScrollbar.$el;
      scrollbar.scrollTop = top - popupTop + scrollbar.scrollTop - 200;
    },
  },
};
</script>
